import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

// RITA-1535 — Zelleneditor für optionale Texte (Vorname, Nachname in Einstellungen › Benutzer): leer ist
// erlaubt und zeigt keinen Fehler, anders als TextEditor für Pflichtfelder. Höchstens 100 Zeichen wie
// die Spalten in der Datenbank; der Spaltentitel dient als Beschriftung für Bedienhilfen und Tests.
export const OPTIONAL_TEXT_MAX_LENGTH = 100;

interface Props {
  value: string | null | undefined;
  onValueChange: (value: string) => void;
  column: { name: string; title?: string };
}

function OptionalTextEditor({ value, onValueChange, column }: Props) {
  return (
    <Box>
      <TextField
        value={value ?? ''}
        onChange={(event) => onValueChange(event.target.value)}
        inputProps={{ maxLength: OPTIONAL_TEXT_MAX_LENGTH, 'aria-label': column.title ?? column.name }}
      />
    </Box>
  );
}

export default OptionalTextEditor;
